<template>
  <div>
    <Spin v-if="loading"></Spin>
    <vxe-table :data="prepayItems" size="mini">
      <vxe-table-column field="FundBillNo" title="BillNo"></vxe-table-column>
      <vxe-table-column field="FundBillDate" title="Date"></vxe-table-column>
      <vxe-table-column field="CurrID" title="Curr"></vxe-table-column>
      <vxe-table-column field="AddMoney" title="Money">
        <template #default="{ row }">{{ intlCurrencyNumber(row.CurrID, row.AddMoney, 5, 5) }}</template>
      </vxe-table-column>
    </vxe-table>
  </div>
</template>

<script>
import { intlCurrencyNumber } from '@/libs/util'
import { mapActions } from 'vuex'
export default {
  name: "ErpOrderPrepays",
  props: {
    orderId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      prepayItems: []
    }
  },
  mounted () {
    this.loadErpPrepays(this.orderId)
  },
  methods: {
    ...mapActions(['getErpPrepays']),
    intlCurrencyNumber,
    loadErpPrepays (orderId) {
      if (!orderId) return

      this.loading = true
      this.getErpPrepays(orderId)
        .then((resp) => {
          this.prepayItems = resp.data
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
  watch: {
    orderId (val) {
      this.loadErpPrepays(val)
    }
  }
}
</script>
